import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=320ad6af&scoped=true&"
import script from "./backend.vue?vue&type=script&lang=js&"
export * from "./backend.vue?vue&type=script&lang=js&"
import style0 from "./backend.vue?vue&type=style&index=0&id=320ad6af&scoped=true&lang=css&"
import style1 from "./backend.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ad6af",
  null
  
)

export default component.exports